export default __webpack_public_path__ + "static/media/trylleby-property-08.c00e1535.jpg";